import { AvailableService } from '../services/Appointment/model';

export const getService = (
  serviceId: string,
  services: AvailableService[] = [],
): AvailableService | undefined => {
  const currentService = services.find(
    (s: AvailableService): boolean => s.id === serviceId,
  );

  return currentService;
};

export const getServiceCode = (
  serviceId: string,
  availableServices: Array<AvailableService>,
) => {
  const serviceObject = availableServices.find(
    (service) => service.id === serviceId,
  );
  const serviceCode = serviceObject?.serviceCode
    ? serviceObject.serviceCode
    : '';

  return serviceCode;
};
